
import axios from 'axios';

import { API_BASE } from '../endpoints';

// Keep baseURL for relative calls; absolute endpoints still work.
const instance = axios.create({ baseURL: API_BASE });
instance.interceptors.request.use(config => {
  const token = localStorage.getItem('token') || sessionStorage.getItem('token');
  const existing = config?.headers?.Authorization;
  if(!existing && token){
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});
// Response interceptor: redirect to themed error pages for common HTTP errors
instance.interceptors.response.use(
  (response) => {
    window.dispatchEvent(new CustomEvent('maintenance:hide'));
    return response;
  },
  (err) => {
    const cfg = err?.config || {};

    if (cfg.skipHttpErrorEvent) return Promise.reject(err);
    if (cfg.skipErrorRedirect) return Promise.reject(err);
    if (cfg.skipMaintenanceRedirect) return Promise.reject(err);

    const status = err.response?.status;

    if (status) {
      if (status === 403) {
        const detail = err.response?.data?.detail;
        if (typeof detail === 'string' && detail.toLowerCase().includes('zablokowane przez moderację')) {
          window.dispatchEvent(new CustomEvent('user:suspended', { detail: err.response?.data }));
        }
      }
      const redirectCodes = [400, 401, 402, 403, 404, 405, 408, 418, 429, 500, 502, 503, 504];
      if (redirectCodes.includes(status)) {
        const payload = { status, data: err.response?.data, config: cfg };
        window.dispatchEvent(new CustomEvent('http:error', { detail: payload }));

        if (status === 500 && !cfg.skipErrorRedirect && window.location.pathname !== '/500') {
          window.location.assign('/500');
        }

        return Promise.reject(err);
      }

      if (status >= 500) {
        const payload = { status, data: err.response?.data, config: cfg };
        window.dispatchEvent(new CustomEvent('http:error', { detail: payload }));
        return Promise.reject(err);
      }
    }

    // Network error / no response
    if (!err.response) {
      if (cfg.skipMaintenanceRedirect) return Promise.reject(err);

      const { pathname = '', search = '' } = window.location || {};
      if (pathname.startsWith('/maintenance')) return Promise.reject(err);

      const last = window.sessionStorage?.getItem('maintenanceRedirectAt');
      const now = Date.now();
      if (last && now - Number(last) < 5000) return Promise.reject(err);
      window.sessionStorage?.setItem('maintenanceRedirectAt', String(now));

      const from = encodeURIComponent(`${pathname}${search || ''}`);
      window.dispatchEvent(new CustomEvent('maintenance:show', { detail: { from } }));
      return Promise.reject(err);
    }

    return Promise.reject(err);
  },
);
export default instance;